// extracted by mini-css-extract-plugin
export default {"root":"ProductsList-root_BA7cE"};